/* eslint-disable no-const-assign */
import axios from 'axios';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../config/Config';
import '../../css/login.css';
import { handleMessage } from '../../helper/utils';
import VerifyOtp from './VerifyOtp';

const Login = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [checkOtp, setCheckOtp] = useState(false);
  const [expiredAfter, setExpiredAfter] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isErrors = {};
    if (!email || email.length <= 0) {
      isErrors = {
        ...isErrors,
        email: t('email_not_empty'),
      };
    }
    if (!password || password.length <= 0) {
      isErrors = {
        ...isErrors,
        password: t('password_not_empty'),
      };
    }
    if (isErrors.email || isErrors.password) {
      setErrors(isErrors);
      return false;
    }
    try {
      const response = await axios.post(config.API_URL.AUTH.LOGIN_V2, { email, password });
      const { data } = response;
      if (response?.status === 201) {
        setExpiredAfter(data?.expiredAfter);
        setCheckOtp(true);
      } else {
        handleMessage('error', 'Username or password is incorrect');
      }
    } catch (errors) {
      handleMessage('error', 'Username or password is incorrect');
    }
  };

  return (
    <>
      <div className="w-full h-full flex justify-center bg-red">
        {!checkOtp ? (
          <form className="login" onSubmit={handleSubmit} style={{ direction: 'rtl' }}>
            <input
              type="text"
              placeholder={t('email')}
              name="email"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
            />
            {errors.email?.length > 0 && (
              <p style={{ color: 'rgba(244, 91, 105, 1)' }}>{errors.email}</p>
            )}
            <input
              type="password"
              placeholder={t('password')}
              name="password"
              onChange={(e) => setPassword(e.target.value)}
              value={password}
            />
            {errors.password?.length > 0 && (
              <p style={{ color: 'rgba(244, 91, 105, 1)' }}>{errors.password}</p>
            )}
            <button type="submit" onClick={handleSubmit}>
              {t('login_button')}
            </button>
          </form>
        ) : (
          <VerifyOtp email={email} expiredAfter={expiredAfter} setCheckOtp={setCheckOtp} />
        )}
      </div>
    </>
  );
};

export default Login;
